<template>
  <div class="content">
    <div class="mt-20">
    </div>
   
  </div>

</template>

<script>
  export default {

    data() {
      return {
      }
    },

    mounted() {
      
    },
    methods: {
     
    },
    computed: {
      
    },
  };
</script>

<style lang='less' scoped>
  .content{
    width: 100%;
    margin: 100px auto 0;
    padding: 3% 0 0;
  }
  .img-title {
    width: 60vw;
    margin-bottom:0.5vw
  }
  .img-content {
    width: 60vw;
    margin-bottom:0.5vw
  }
  .img-bottom {
    display: block;
    width: 100%;
    height: 100px;
    margin-top: 200px;
  }
  .mt-20 {
    margin-top: 40vh;
  }
</style>




// WEBPACK FOOTER //
// src/components/Content.vue